import React, { useReducer, useState, useMemo } from 'react'
import { Form, Button, Icon } from 'semantic-ui-react'
import { tap, finalize } from 'rxjs/operators'
import { cpfCnpj, download } from '@rededompedro/utils'
import request from 'services/http'
import { toast } from 'react-toastify'
import { useSubscription } from 'utils'

function reducer(state, action) {
    switch (action.type) {
        case 'setForm':
            return { ...state, ...action.payload }
        default:
            return state
    }
}

export default function DownloadCertificateForm({ empresas }) {

    const [isLoading, setLoading] = useState(false)
    const [state, dispatch] = useReducer(reducer, {
        empresa: '',
        cnpj: ''
    })

    const downloadCert$  = useMemo(() => request({ 
        url: '/empresas/certificado/download', 
        method: 'POST', 
        body: state, 
        responseType: 'blob' 
    }).pipe(
        tap(({ response }) => download(response, empresas.find(x => x && x._id === state.empresa).nomeEmpresa.toLowerCase().replace(/\s/g, '_') + ".pfx")),
        finalize(() => setLoading(false))
    ), [state, empresas])

    function handleChange(_, { name, value }) {
        if (name === 'empresa' && empresas.find(x => x && x._id === value).certificados.length === 1)
            dispatch({ type: 'setForm', payload: { [name]: value, cnpj: empresas.find(x => x && x._id === value).certificados[0].cnpj } })
        else if (name === 'empresa' && empresas.find(x => x && x._id === value).certificados.length > 1)
            dispatch({ type: 'setForm', payload: { [name]: value, cnpj: '' } })
        else
            dispatch({ type: 'setForm', payload: { [name]: value } })
    }

    function handleSubmit() {
        if (!(!!state.empresa) || !(!!state.cnpj))
            toast.error('Por favor, preencha o formulário antes de enviar.')
        else  
            setLoading(true)
    }

    useSubscription(downloadCert$, isLoading)

    return (
        <Form size='mini'className='w-100' onSubmit={handleSubmit} loading={isLoading} noValidate>
            <div className='row'>
                <div className="col col-md-8 offset-md-2">
                    <Form.Select required label='Empresa' search noResultsMessage='Sem resultados' placeholder='Selecione a empresa desejada' name='empresa' value={state.empresa} onChange={handleChange} options={empresas.map(x => Object.assign({}, { text: x.codDpnet + " - " + x.nomeEmpresa, value: x._id }))} />
                </div>
            </div>
            {(!!state.empresa) && <div className='row pt-3'>
                <div className="col col-md-8 offset-md-2">
                    {empresas.find(x => x && x._id === state.empresa).certificados.length > 1 && 
                    <Form.Select required label='CNPJ' placeholder='Selecione o CNPJ' name='cnpj' value={state.cnpj} onChange={handleChange} options={empresas.find(x => x && x._id === state.empresa).certificados.map(x => Object.assign({}, { text: cpfCnpj(x.cnpj), value: x.cnpj }))} />}
                    {empresas.find(x => x && x._id === state.empresa).certificados.length === 1 &&
                    <Form.Input required label='CNPJ' readOnly name='cnpj' value={cpfCnpj(state.cnpj)} />}
                </div>
            </div>}
            {(!!state.empresa) && (!!state.cnpj) && <div className='row pt-3'>
                <div className="col col-md-8 offset-md-2">
                    <Form.Input label='Senha' readOnly name='senha' value={empresas.find(x => x && x._id === state.empresa).certificados.find(x => x && x.cnpj === state.cnpj).pwd} />
                </div>
            </div>}

            <div className="row pt-3">
                <div className="col text-center">
                    <Button animated='fade' size='mini' color='green'>
                        <Button.Content visible>Download</Button.Content>
                        <Button.Content hidden><Icon name='download' /></Button.Content>
                    </Button>
                </div>
            </div>
        </Form>
    )
}
